export function getX(pos) {
    if (Array.isArray(pos)) {
        return pos[0];
    }
    return 0;
}
export function getY(pos) {
    if (Array.isArray(pos)) {
        return pos[1];
    }
    return 0;
}
export function getZ(pos) {
    if (Array.isArray(pos)) {
        return pos[2];
    }
    return 0;
}
export function updatePosX(pos, dx) {
    if (Array.isArray(pos)) {
        const x = getX(pos) + dx;
        const y = getY(pos);
        const z = getZ(pos);
        return [x, y, z];
    }
    return pos;
}
export function updatePosZ(pos, dz) {
    if (Array.isArray(pos)) {
        const x = getX(pos);
        const y = getY(pos);
        const z = getZ(pos) + dz;
        return [x, y, z];
    }
    return pos;
}
export function updatePosY(pos, dy) {
    if (Array.isArray(pos)) {
        const x = getX(pos);
        const y = getY(pos) + dy;
        const z = getZ(pos);
        return [x, y, z];
    }
    return pos;
}
